import { GET_TABLE_FILTERS } from './getTableFilters';
import { CREATE_TABLE_FILTER } from './createTableFilter';
import { UPDATE_TABLE_FILTER } from './updateTableFilter';
import { DELETE_TABLE_FILTER } from './deleteTableFilter';
import { TOGGLE_DEFAULT_TABLE_FILTER } from './toggleDefaultTableFilter';

export const tableFilterApi = {
  getTableFilters: GET_TABLE_FILTERS,
  createFilter: CREATE_TABLE_FILTER,
  updateFilter: UPDATE_TABLE_FILTER,
  deleteFilter: DELETE_TABLE_FILTER,
  toggleDefaultTableFilter: TOGGLE_DEFAULT_TABLE_FILTER,
};

export * from './types';
